<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path d="M134.9 937.5c-9.4 0-18.3-3.4-25.3-9.5h-.1l-1.8-1.7c-7.3-7.3-11.3-16.9-11.3-27.2s4-19.9 11.3-27.2l752.1-752.1c7.2-7 16.7-10.8 26.7-10.8 10.3 0 19.9 4 27.2 11.3 14.8 14.7 15 38.9.5 53.9L162.1 926.3c-7.3 7.2-16.9 11.2-27.2 11.2zm453.1-8.1c-21.2 0-38.5-17.3-38.5-38.5s17.3-38.5 38.5-38.5h325.6c21.2 0 38.5 17.3 38.5 38.5s-17.3 38.5-38.5 38.5H588zm0-173.6c-21.2 0-38.5-17.3-38.5-38.5s17.3-38.5 38.5-38.5h325.6c21.2 0 38.5 17.3 38.5 38.5s-17.3 38.5-38.5 38.5H588zM273.3 484.5c-21.2 0-38.5-17.3-38.5-38.5V321.7H110.5c-21.2 0-38.5-17.3-38.5-38.5s17.3-38.5 38.5-38.5h124.3V120.4c0-21.2 17.3-38.5 38.5-38.5s38.5 17.3 38.5 38.5v124.3H436c21.2 0 38.5 17.3 38.5 38.5s-17.3 38.5-38.5 38.5H311.7V446c0 21.2-17.2 38.5-38.4 38.5z" data-follow-fill="currentColor" :fill="_fill" /></g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
